import {tv, type VariantProps} from 'tailwind-variants'
import HgTooltip, {type HgTooltipProps} from '../HgTooltip'
import {type ReactNode} from 'react'

const hgTextOutputVariants = tv({
  slots: {
    wrapper: 'flex flex-col gap-s3 border-solid border-border-frosted p-s5 ',
    outputText: 'text-text-default',
  },
  variants: {
    size: {
      small: {
        outputText: 'arcadia-heading-5',
      },
      medium: {
        outputText: 'arcadia-display-8',
      },
      large: {
        outputText: 'arcadia-display-6',
      },
    },
    bottomPadding: {
      s5: {
        wrapper: 'pb-s5',
      },
      s7: {
        wrapper: 'pb-s7',
      },
    },
    hasBottomBorder: {
      true: {
        wrapper: 'border-b',
      },
    },
  },
})

export type HgTextOutputProps = {
  label: ReactNode
  text: ReactNode
  hintProps?: Pick<HgTooltipProps, 'content' | 'variant' | 'title'>
  className?: string
} & VariantProps<typeof hgTextOutputVariants>

const HgTextOutput = ({
  label,
  text,
  hintProps,
  size = 'medium',
  bottomPadding = 's5',
  hasBottomBorder,
  className,
}: HgTextOutputProps) => {
  const {wrapper, outputText} = hgTextOutputVariants({
    size,
    bottomPadding,
    hasBottomBorder,
  })
  return (
    <div className={wrapper({class: className})}>
      <p className=" text-icon-subdued text-text-subdued arcadia-ui-2">
        {label}
        {hintProps?.content && (
          <HgTooltip {...hintProps} classNames={{trigger: 'ms-s1'}} />
        )}
      </p>
      <p className={outputText()}>{text}</p>
    </div>
  )
}

export default HgTextOutput
